import { createContext } from 'react';

const ScoreContext = createContext();

export default ScoreContext;